import { useEffect } from 'react';

export const updateMetaTag = (name: string, content: string | undefined) => {
    if (!content) return;
    let element = document.querySelector(`meta[name="${name}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', name);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
};

export const updateOgTag = (property: string, content: string | undefined) => {
    if (!content) return;
    let element = document.querySelector(`meta[property="og:${property}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', `og:${property}`);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
};

export const updateFavicon = (href: string | undefined) => {
    if (!href) return;
    let element = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', 'icon');
        document.head.appendChild(element);
    }
    element.href = href;
};

interface SEOProps {
    title?: string;
    description?: string;
    ogImage?: string;
    ogType?: string;
}

export const useSEO = ({ title, description, ogImage, ogType = 'website' }: SEOProps, dependencies: any[] = []) => {
    useEffect(() => {
        if (title) {
            document.title = title;
            updateOgTag('title', title);
        }
        if (description) {
            updateMetaTag('description', description);
            updateOgTag('description', description);
        }
        if (ogImage) {
            updateOgTag('image', ogImage);
        }
        updateOgTag('type', ogType);
    }, dependencies);
};
